<template>
   <div>
      <h3 class="section-title">Personal Information</h3>
      <p class="instructions">Important: Feel free to save this form anytime without submitting it using the green save button. Once completed, click Submit to send it to Manhattan for approval. 
         Note that each individual section may need you to agree, approve, or certify with an electronic signature.</p>

      <!-- Personal Data -->
      <fieldset class="border p-2 marb-12">
         <legend class="w-auto">Personal Data</legend>

         <section-bar>Basics</section-bar>
         <div class="form-group row" >
            <field-col name="personal.firstName" label="First Name" v-model="p.firstName" :v$="v$.personal.firstName" @change="storeW9Info(), updateAgentName()" lcols="2" icols="4"></field-col>
            <field-col name="personal.lastName" label="Last Name" v-model="p.lastName" :v$="v$.personal.lastName" @change="storeW9Info(), updateAgentName()" lcols="2" icols="4"></field-col>
         </div>
         <div class="form-group row">
            <field-col name="personal.middleName" label="Middle Initial" v-model="p.middleName" :v$="v$.personal.middleName" @change="storeW9Info(), updateAgentName()" lcols="2" icols="4"></field-col>
            <field-col name="personal.ssn" label="SSN" v-model="p.ssn" :v$="v$.personal.ssn" @change="storeW9Info(), updateAgentName()" lcols="2" icols="4"></field-col>
         </div>
         <div class="form-group row">
            <field-col name="personal.residentStateInsuranceLicenseNumber" label="Resident State Ins. License#" v-model="p.residentStateInsuranceLicenseNumber" :v$="v$.personal.residentStateInsuranceLicenseNumber" @change="chg" lcols="4" icols="8"></field-col>
         </div>
         <div class="form-group row">
            <label for="personal.birthDate" class="col-sm-2 col-form-label">Birth Date</label>
            <div class="col-sm-4">
               <input type="date" class="form-control" id="personal.birthDate" @blur="v$.personal.birthDate.$touch" v-model="p.birthDate"
                  :class="{ 'error--input': v$.personal.birthDate.$error }" @change="chg" :readonly="$parent.readOnly()" />
               <div class="error--msg" v-if="v$.personal.birthDate.$error">
                  {{ v$.personal.birthDate.required.$message }}
               </div>
            </div>
            <field-col name="personal.emailAddress" label="Email Address" v-model="p.emailAddress" :v$="v$.personal.emailAddress" @change="chg(true)"  lcols="2" icols="4" typ="email" :viewOnly="isVB ? true : false"></field-col>
         </div>
         <div class="form-group row">
            <field-col name="personal.nationalProducerNumber" label="NPN#" v-model="p.nationalProducerNumber" :v$="v$.personal.nationalProducerNumber" @change="chg" lcols="2" icols="4"></field-col>
            <field-col name="personal.driverLicenseNumber" label="Drivers License#" v-model="p.driverLicenseNumber" :v$="v$.personal.driverLicenseNumber"  @change="chg" lcols="2" icols="4"></field-col>
         </div>

         <section-bar>Home Address</section-bar>
         <div class="form-group row">
            <field-col name="homeAddress.address1" label="Address" v-model="homeAddress.address1" :v$="v$Home.address1" @change="chg" lcols="2" icols="4"></field-col>
            <field-col name="personal.cellNumber" label="Phone Number" v-model="p.cellNumber" :v$="v$.personal.cellNumber"  @change="chg" lcols="2" icols="4"></field-col>
         </div>
         <div class="form-group row">
            <field-col name="homeAddress.city" label="City" v-model="homeAddress.city" :v$="v$Home.city" @change="chg" lcols="2" icols="4"></field-col>

            <label for="stateCode" class="col-sm-2 col-form-label" :class="{ 'error--label': v$Home.stateCode.$error }">State</label>
            <div class="col-sm-4">
               <select class="form-control" id="homeAddress.stateCode" aria-placeholder="(choose a state)" @blur="v$Home.stateCode.$touch"
                  v-model="homeAddress.stateCode" @change="chg" :class="{ 'error--input': v$Home.stateCode.$error }" :disabled="$parent.readOnly()">
                  <option :value="null" disabled hidden>(Choose a State)</option>
                  <option value="AA">Asia</option>
                  <option value="AK">Alaska</option>
                  <option value="AL">Alabama</option>
                  <option value="AR">Arkansas</option>
                  <option value="AS">American Samoa</option>
                  <option value="AZ">Arizona</option>
                  <option value="BC">British Columbia</option>
                  <option value="CA">California</option>
                  <option value="CM">Northern Mariana Islands</option>
                  <option value="CN">Canada</option>
                  <option value="CO">Colorado</option>
                  <option value="CT">Connecticut</option>
                  <option value="DC">District of Columbia</option>
                  <option value="DE">Delaware</option>
                  <option value="FL">Florida</option>
                  <option value="GA">Georgia</option>
                  <option value="GU">Guam</option>
                  <option value="HI">Hawaii</option>
                  <option value="IA">Iowa</option>
                  <option value="ID">Idaho</option>
                  <option value="IL">Illinois</option>
                  <option value="IN">Indiana</option>
                  <option value="KS">Kansas</option>
                  <option value="KY">Kentucky</option>
                  <option value="LA">Louisiana</option>
                  <option value="LT">Latin America</option>
                  <option value="MA">Massachusetts</option>
                  <option value="MD">Maryland</option>
                  <option value="ME">Maine</option>
                  <option value="MI">Michigan</option>
                  <option value="MN">Minnesota</option>
                  <option value="MO">Missouri</option>
                  <option value="MS">Mississippi</option>
                  <option value="MT">Montana</option>
                  <option value="NB">New Brunswick</option>
                  <option value="NC">North Carolina</option>
                  <option value="ND">North Dakota</option>
                  <option value="NE">Nebraska</option>
                  <option value="NH">New Hampshire</option>
                  <option value="NJ">New Jersey</option>
                  <option value="NM">New Mexico</option>
                  <option value="NV">Nevada</option>
                  <option value="NY">New York</option>
                  <option value="OC">Foreign Country</option>
                  <option value="OH">Ohio</option>
                  <option value="OK">Oklahoma</option>
                  <option value="OR">Oregon</option>
                  <option value="PA">Pennsylvania</option>
                  <option value="PR">Puerto Rico</option>
                  <option value="RI">Rhode Island</option>
                  <option value="SC">South Carolina</option>
                  <option value="SD">South Dakota</option>
                  <option value="TN">Tennessee</option>
                  <option value="TX">Texas</option>
                  <option value="UT">Utah</option>
                  <option value="VA">Virginia</option>
                  <option value="VI">Virgin Islands</option>
                  <option value="VT">Vermont</option>
                  <option value="WA">Washington</option>
                  <option value="WI">Wisconsin</option>
                  <option value="WV">West Virginia</option>
                  <option value="WY">Wyoming</option>
               </select>
               <div class="error--msg" v-if="v$Home.stateCode.$error">
                  {{ $parent.errorText(v$Home.stateCode) }}
               </div>
            </div>
         </div>
         <div class="form-group row">
            <field-col name="homeAddress.zipCode" label="Zip Code" v-model="homeAddress.zipCode" :v$="v$Home.zipCode" @change="chg" lcols="2" icols="4"></field-col>
            <field-col  v-if="showType(['I','VI'])" name="personal.businessFaxNumber" label="Fax Number" v-model="p.businessFaxNumber" :v$="v$.personal.businessFaxNumber"  @change="chg" lcols="2" icols="4"></field-col>
         </div>

         <template v-if="showType(['C','B','R','I','P','VC','VB','VR','VI','VP'])">
            <template v-if="showType(['C','B','VC','VB'])">
               <section-bar>Business Information</section-bar>
               <div class="form-group row">
                  <field-col  name="personal.businessName" label="Business Name" v-model="p.businessName" :v$="v$.personal.businessName"  @change="storeW9Info(), chg()" lcols="2" icols="4"></field-col>
                  <field-col  name="personal.businessTaxID" label="Corporate Tax Id" v-model="p.businessTaxID" :v$="v$.personal.businessTaxID"  @change="chgCorpTaxId(), storeW9Info(), chg()" lcols="2" icols="4"></field-col>
               </div>
               <div class="form-group row">
                  <label for="bizName" class="col-sm-2 col-form-label">Type</label>
                  <div class="col-sm-4">
                     <input type="text" readonly class="form-control-plaintext ml-corp" v-model="businessType" @change="chg">
                  </div>
               </div>
            </template>

            <fieldset id="businessAddressFields">
            <section-bar>Business Address</section-bar>
            <div v-if="(this.apptType == 'APPTTYP_IND' || this.apptType == 'APPTTYP_WVB') && !$parent.readOnly() && apptStatusCode != 'APWF_STATUS_ABANDONED'" class="form-group row">
               <div class="col-sm-12">   
                  <div class="custom-control form-control-lg custom-checkbox font-smaller copy-addr">                  
                     <input type="checkbox" class="custom-control-input chk-mail-adr" id="saveAddress" v-model="copyAddress" @change="saveAddChg">
                     <label class="custom-control-label chk-mail-adr-label" for="saveAddress">Same as Mailing Address</label>
                  </div>
               </div>                                
            </div>            
            <div class="form-group row">
               <field-col name="bizAddress.address1" label="Address" v-model="bizAddress.address1" :v$="v$Biz.address1" @change="chg" lcols="2" icols="4"></field-col>
               <field-col name="personal.businessCellNumber" label="Phone Number" v-model="p.businessCellNumber" :v$="v$.personal.businessCellNumber"  @change="chg" lcols="2" icols="4"></field-col>
            </div>
            <div class="form-group row">
               <field-col name="bizAddress.city" label="City" v-model="bizAddress.city" :v$="v$Biz.city" @change="chg" lcols="2" icols="4"></field-col>
               <label for="bizstateCode" class="col-sm-2 col-form-label" :class="{ 'error--label': v$Biz.stateCode.$error }">State</label>
               <div class="col-sm-4">
                  <select class="form-control" id="bizstateCode" aria-placeholder="(choose a state)"  @blur="v$Biz.stateCode.$touch"
                     v-model="bizAddress.stateCode" @change="chg" :class="{ 'error--input': v$Biz.stateCode.$error }" :disabled="$parent.readOnly()">
                     <option :value="null" disabled hidden>(Choose a State)</option>
                     <option value="AA">Asia</option>
                     <option value="AK">Alaska</option>
                     <option value="AL">Alabama</option>
                     <option value="AR">Arkansas</option>
                     <option value="AS">American Samoa</option>
                     <option value="AZ">Arizona</option>
                     <option value="BC">British Columbia</option>
                     <option value="CA">California</option>
                     <option value="CM">Northern Mariana Islands</option>
                     <option value="CN">Canada</option>
                     <option value="CO">Colorado</option>
                     <option value="CT">Connecticut</option>
                     <option value="DC">District of Columbia</option>
                     <option value="DE">Delaware</option>
                     <option value="FL">Florida</option>
                     <option value="GA">Georgia</option>
                     <option value="GU">Guam</option>
                     <option value="HI">Hawaii</option>
                     <option value="IA">Iowa</option>
                     <option value="ID">Idaho</option>
                     <option value="IL">Illinois</option>
                     <option value="IN">Indiana</option>
                     <option value="KS">Kansas</option>
                     <option value="KY">Kentucky</option>
                     <option value="LA">Louisiana</option>
                     <option value="LT">Latin America</option>
                     <option value="MA">Massachusetts</option>
                     <option value="MD">Maryland</option>
                     <option value="ME">Maine</option>
                     <option value="MI">Michigan</option>
                     <option value="MN">Minnesota</option>
                     <option value="MO">Missouri</option>
                     <option value="MS">Mississippi</option>
                     <option value="MT">Montana</option>
                     <option value="NB">New Brunswick</option>
                     <option value="NC">North Carolina</option>
                     <option value="ND">North Dakota</option>
                     <option value="NE">Nebraska</option>
                     <option value="NH">New Hampshire</option>
                     <option value="NJ">New Jersey</option>
                     <option value="NM">New Mexico</option>
                     <option value="NV">Nevada</option>
                     <option value="NY">New York</option>
                     <option value="OC">Foreign Country</option>
                     <option value="OH">Ohio</option>
                     <option value="OK">Oklahoma</option>
                     <option value="OR">Oregon</option>
                     <option value="PA">Pennsylvania</option>
                     <option value="PR">Puerto Rico</option>
                     <option value="RI">Rhode Island</option>
                     <option value="SC">South Carolina</option>
                     <option value="SD">South Dakota</option>
                     <option value="TN">Tennessee</option>
                     <option value="TX">Texas</option>
                     <option value="UT">Utah</option>
                     <option value="VA">Virginia</option>
                     <option value="VI">Virgin Islands</option>
                     <option value="VT">Vermont</option>
                     <option value="WA">Washington</option>
                     <option value="WI">Wisconsin</option>
                     <option value="WV">West Virginia</option>
                     <option value="WY">Wyoming</option>
                  </select>
                  <div class="error--msg" v-if="v$Biz.stateCode.$error">
                     {{ $parent.errorText(v$Biz.stateCode) }}
                  </div>
               </div>
            </div>
            <div class="form-group row">
               <field-col name="bizAddress.zipCode" label="Zip Code" v-model="bizAddress.zipCode" :v$="v$Biz.zipCode" @change="chg" lcols="2" icols="4"></field-col>
               <field-col name="personal.businessFaxNumber2" label="Fax Number" v-model="p.businessFaxNumber" :v$="v$.personal.businessFaxNumber"  @change="chg" lcols="2" icols="4"></field-col>
            </div>
            </fieldset>
         </template>

         <section-bar>Other</section-bar>
         <div class="form-group row">
            <label for="bizName" class="col-sm-2 col-form-label" :class="{ 'error--label': v$.personal.sendCorrespondenceToCode.$error }">Correspondence</label>
            <div class="col-sm-4">
               <select class="form-control" id="personal.sendCorrespondenceToCode" @blur="v$.personal.sendCorrespondenceToCode.$touch"
                  v-model="p.sendCorrespondenceToCode" @change="chg" :class="{ 'error--input': v$.personal.sendCorrespondenceToCode.$error }" :disabled="$parent.readOnly()">
                  <option :value="null" disabled hidden>(Choose a Destination)</option>
                  <option value='R'>Send to my Residence</option>
                  <option value='C'>Send to my Business</option>
               </select>
               <div class="error--msg" v-if="v$.personal.sendCorrespondenceToCode.$error">
                  {{ $parent.errorText(v$.personal.sendCorrespondenceToCode) }}
               </div>
            </div>
         </div>

      </fieldset>

      <!-- QnA -->
      <fieldset class="border p-2 marb-12">
         <legend class="w-auto">Questions and Answers</legend>
         <section-bar>Application Q&amp;A</section-bar>
         <div class="qna marb-12 border-bottom">
            <table class="table table-condensed question-table">
               <thead>
                  <tr><th colspan="2" id="personal.answers">Answer the following Questions</th></tr>
                  <tr v-if="v$.answers.$error" class="tderror--label"><th colspan="2" class="error--msg">Answers Required</th></tr>
               </thead>
               <tbody>
                  <tr v-for="q in questions" :key="q.questionId" :class="{ 'tderror--label': hasNoAnswer(q.questionId) }">
                     <td :colspan="isTextOnly(q)">
                        <span v-if="isSub(q)" class="poor-indent">&nbsp;</span>
                        {{q.questionText}}
                     </td>
                     <td class="yn-col" v-if="!q.isTextOnly">
                        <div class="custom-control custom-radio custom-control-inline">
                           <input type="radio" :id="'rad'+q.questionId" :name="'ans'+q.questionId" :disabled="$parent.readOnly()" 
                              class="custom-control-input" :value="true" @change="v$.answers.$touch(); chg();" 
                              v-model="getAnswer(q.questionId).answerBoolean">
                           <label class="custom-control-label" :for="'rad'+q.questionId">Yes</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                           <input type="radio" :id="'radN'+q.questionId" :name="'ans'+q.questionId" :disabled="$parent.readOnly()" 
                              class="custom-control-input" :value="false" @change="v$.answers.$touch(); chg();" 
                              v-model="getAnswer(q.questionId).answerBoolean">
                           <label class="custom-control-label" :for="'radN'+q.questionId">No</label>
                        </div>
                     </td>
                  </tr>
               </tbody>
            </table>
         </div>

         <div class="row mart-12">
            <div class="col font-smaller">
               As part of our contracting process due diligence, several inquiries will be made including a check of state 
               and federal court records, a credit check, a Vector One check for agent commission debit balances and a 
               routine investigative consumer report whereby information is obtained through personal interviews with your 
               neighbors, friends or others with whom you are acquainted. These inquiries include information concerning 
               criminal court reports, credit history, unpaid agent commission debit balances, character, general 
               reputation, personal characteristics and mode of living. As applicable, employment, occupation, general 
               health, habits, residence verification and marital status may be included. You have the right to make a 
               written request within a reasonable period to receive additional detailed information about the nature and 
               scope of this investigation.   You authorize all persons    and entities to release all written and verbal 
               information about you to Vector One, Applicant Insight Limited, Inc., Manhattan Life Insurance, Family Life 
               Insurance Company, ManhattanLife Assurance Company of America, Standard Life and Casualty Insurance Company, 
               ManhattanLife of America Insurance Company and Western United Life Assurance Company. You release and agree 
               to hold Manhattan Life Insurance, Family Life Insurance Company, ManhattanLife Assurance Company of America, 
               Standard Life and Casualty Insurance Company, ManhattanLife of America Insurance Company, Western United 
               Life Assurance Company, Vector One and Insight Limited, Inc. harmless from all liability and responsibility 
               for doing so. You also authorize the procurement of an investigative consumer credit report and Vector One 
               inquiry.
            </div>
         </div>

         <div class="row comment-field">
            <div class="col-2">Comments</div>
            <div class="col-10">
               <textarea rows="6" class="form-control" v-model="comment" placeholder="(add multiple lines)" :disabled="$parent.readOnly()" @change="chg"></textarea>
            </div>
         </div>

         <section-bar>Certified by the Applicant</section-bar>
         <p class="instructions">Please enter your mother's maiden name indicating the above answers are correct to the best of your ability.</p>
         <div class="form-group row" v-if="!gettingSigs">
            <label for="qaSig" class="col-sm-4 col-form-label" :class="{ 'error--label': v$.signatures.$dirty && v$.signatures.hasSigQA.$invalid }">Mother's Maiden Name</label>
            <div class="col-sm-4">
               <input type="text" class="form-control" id="qaSig" placeholder="(mother's maiden name)" :readonly="$parent.readOnly()"
                  v-model="signatures[qna].signatureValue" @change="sigUpdate" @blur="v$.signatures.$touch()"
                  :class="{ 'error--input': v$.signatures.$dirty && v$.signatures.hasSigQA.$invalid }">
               <div class="error--msg" v-if="v$.signatures.$dirty && v$.signatures.hasSigQA.$invalid">
                  {{ v$.signatures.hasSigQA.$message }}
               </div>
            </div>
         </div>
      </fieldset>

      <!-- W9 -->
      <fieldset class="border p-2 marb-12" v-if="showType(['C','B','I','VC','VB','VI'])">
         <legend class="w-auto">W-9 Tax Form and Certification</legend>
         <section-bar>Identification for W-9 Form</section-bar>
         <div class="form-group row">
            <field-col id="apptIRSInfo.name" name="apptIRSInfo.name" label="Name" v-model="irs.name" :v$="v$.apptIRSInfo.name"  @change="chg" lcols="3" icols="8"></field-col>
         </div>
         <div class="form-group row">
            <field-col id="apptIRSInfo.businessName" name="apptIRSInfo.businessName" label="Business Name" v-model="irs.businessName" :v$="v$.apptIRSInfo.businessName"  @change="irsInfoBusinessNameChange(),chg()" lcols="3" icols="8"></field-col>
         </div>
         <div class="form-group row">
            <label id="apptIRSInfo.businessTypeCode" for="w9bizType" class="col-sm-3 col-form-label" :class="{ 'error--label': v$.apptIRSInfo.businessTypeCode.$error }">Type of Business</label>
            <div class="col-sm-8">
               <select class="form-control" placeholder="(choose one)" id="w9bizType" 
                  v-model="irs.businessTypeCode" @blur="v$.apptIRSInfo.businessTypeCode.$touch()" :disabled="$parent.readOnly()"
                  @change="chg" :class="{ 'error--input': v$.apptIRSInfo.businessTypeCode.$error }">
                  <option value='W9BIZ_TYP_IND'>Individual or Sole-Proprietorship</option>
                  <option value='W9BIZ_TYP_CCORP'>C Corporation</option>
                  <option value='W9BIZ_TYP_SCORP'>S Corporation</option>
                  <option value='W9BIZ_TYP_LLC'>Limited Liability Company</option>
                  <option value='W9BIZ_TYP_OTHER'>Other</option>
               </select>
               <div class="error--msg" v-if="v$.apptIRSInfo.businessTypeCode.$error">
                  {{ $parent.errorText(v$.apptIRSInfo.businessTypeCode) }}
               </div>
            </div>
         </div>
         <input type="hidden" v-model="irs.employerIdNumber">

         <section-bar>Certified by the Applicant</section-bar>
         <p class="instructions">
            <!-- Please enter your mother's maiden name indicating the above is correct to the best of your knowledge. -->
            Under penalties of perjury, I certify that:
         </p>
         <p class="instructions">
            1. The number shown on this form is my correct taxpayer identification number (or I am waiting for a number to be issued to me), <strong>and</strong>
         </p>
         <p class="instructions">
            2. I am not subject to backup withholding because: (a) I am exempt from backup withholding, or (b) I have not been notified by the Internal Revenue Service (IRS) that I am subject to backup withholding as a result of a failure to report all interest or dividends, or (c) the IRS has notified me that I am no longer subject to backup withholding, <strong>and</strong>
         </p>
         <p class="instructions">
            3. I am a U.S. person (including a U.S. resident alien).
         </p>
         <div class="form-group row" v-if="!gettingSigs">
            <label for="w9Sig" class="col-sm-4 col-form-label" :class="{ 'error--label': v$.signatures.$dirty && v$.signatures.hasSigW9.$invalid }">Mother's Maiden Name</label>
            <div class="col-sm-4">
               <input type="text" class="form-control" id="w9Sig" placeholder="(mother's maiden name)" :readonly="$parent.readOnly()"
                  v-model="signatures[w9].signatureValue" @change="chg" @blur="v$.signatures.$touch()" 
                  :class="{ 'error--input': v$.signatures.$dirty && v$.signatures.hasSigW9.$invalid }">
               <div class="error--msg" v-if="v$.signatures.$dirty && v$.signatures.hasSigW9.$invalid">
                  {{ v$.signatures.hasSigW9.$message }}
               </div>
            </div>
         </div>

      </fieldset>
   </div>
</template>

<script>
import moment from "moment";
import FieldCol from "../fieldCol.vue";

export default {
   name: "personalView",
   components: {
      'field-col': FieldCol,
   },
   props: { 
      'questions': Array,
      'apptType': String,
      'apptStatusCode': String,      
      'apptId': Number,
      'personal': Object,
      'addresses': Array,
      'sigs': Array,
      'apptIRSInfo': Object,
      'answers': Array,
      'comments': String,
      'v$': Object,
      'v$Home': Object,
      'v$Biz': Object,
      'initialized': Boolean
   },
   data() {
      return {
         p: {},
         adrs: [],
         irs: {
            name: '',
            businessName: '',
            employerIdNumber: ''
         },
         homeAddress: {},
         homeAddressIndex: 0,
         bizAddress: {},
         bizAddressIndex: 0,
         signatures: [],
         qna: null,
         w9: null,
         agtN: null,
         agreeAgtN: null,
         answerCol: [],
         gettingSigs: true,
         comment: this.comments,
         agentName: '',
         copyAddress:false,
      };
   },
   computed: {
      businessType() {
         let typ = 'Individual'
         switch(this.apptType)
         {
            case 'APPTTYP_IND':
            case 'APPTTYP_WVB':
            case 'APPTTYP_REP':
            case 'APPTTYP_PRIN':
            case 'APPTTYP_VB_REP':
               typ = 'Individual'
               break
            case 'APPTTYP_CORP':
            case 'APPTTYP_VB_CORP':
            case 'APPTTYP_VB_BOTH':
            case 'APPTTYP_BOTH':
               typ = 'Corporation'
               break
         }
         return typ
      },
      isVB() {
         let r
         switch (this.apptType) {
            case 'APPTTYP_WVB':
            case 'APPTTYP_VB_BOTH':
            case 'APPTTYP_VB_CORP':
               r = true
               break
            default:
               r = false
               break
         }
         return r
      }
   },
   mounted() {
      // copy the props so they aren't mutated
      this.p = JSON.parse(JSON.stringify(this.personal)) //deep copy
      if (this.addresses) {
         this.adrs = JSON.parse(JSON.stringify(this.addresses)) //deep copy
      }
      if (this.sigs) {
         this.signatures = JSON.parse(JSON.stringify(this.sigs)) //deep copy
      }
      if (this.apptIRSInfo) {
         this.irs = JSON.parse(JSON.stringify(this.apptIRSInfo)) //deep copy
      }
      if (this.answers) {
         this.answerCol = JSON.parse(JSON.stringify(this.answers)) //deep copy
      }
      
      this.storeAddresses()
      this.storeSignatures()
      this.gettingSigs = false
      this.storeIRS()
      this.chgCorpTaxId()
      this.storeW9Info(true)
   },
      methods: {
      combineForDisplay(ra) {
         if (!ra) return;

         const a1 = (ra.address1 || '').trim();
         const a2 = (ra.address2 || '').trim();

         // display combined value: prefer "a1a2", or single one if the other is empty
         return a1 ? (a2 ? `${a1}${a2}` : a1) : a2 || '';
      },
      inputChanged: function(event){
         this.p.firstName = event
      },
      today() {
         return moment(new Date()).format("YYYY-MM-DD")
      },
      isTextOnly(q) {
         if (q.isTextOnly) return 2
         return 1
      },
      getAnswer(questionId) {
         let answer = this.answerCol.find(a => a.questionId == questionId)
         if (answer === undefined) {
            answer = {
               answerBoolean: null,
               answerText: null,
               appointmentId: this.apptId,
               questionId: questionId,
               questionType: "QUES_TYP_PERSONAL"
            }
            this.answerCol.push(answer)
         }
         return answer
      },
      hasNoAnswer(questionId) {
         if (!this.v$.answers.$dirty) return false
         let answer = this.answerCol.find(a => a.questionId == questionId)
         if (answer !== undefined && answer.answerBoolean == null) return true
         return false
      },
      storeIRS() {
         if (this.irs == null) {
            this.irs = {
               appointmentId: this.apptId,  
               name: '',
               businessName: '',
               businessTypeCode: '',   
               businessTypeOther: '',   
               employerIdNumber: ''
            }
         }
      },
      storeAddresses() {
         this.homeAddress = this.addressByType('ADRTYP_HOME')
         if (this.homeAddress==null) {
            this.homeAddress = {
               appointmentAddressId: 0,
               appointmentId: this.apptId,
               addressTypeId: 0,
               address1: '',
               address2: '',
               city: '',
               stateCode: '',
               zipCode: '',
               addressTypeCode: 'ADRTYP_HOME'
            }
            this.homeAddressIndex = this.adrs.length
            this.adrs.push(this.homeAddress)
         }
         this.bizAddress = this.addressByType('ADRTYP_BUSINESS')
         if (this.bizAddress==null) {
            this.bizAddress = {
               appointmentAddressId: 0,
               appointmentId: this.apptId,
               addressTypeId: 0,
               address1: '',
               address2: '',
               city: '',
               stateCode: '',
               zipCode: '',
               addressTypeCode: 'ADRTYP_BUSINESS'
            }
            this.bizAddressIndex = this.adrs.length
            this.adrs.push(this.bizAddress)
         }

         this.homeAddress.address1 = this.combineForDisplay(this.homeAddress);
         this.bizAddress.address1 = this.combineForDisplay(this.bizAddress);
      },
      storeSignatures() {
         this.qna = this.signatureByType('SIGTYP_QNA')
         if (this.qna==null) {
            let qsig = {
               appointmentId: this.apptId,
               signatureTypeCode: 'SIGTYP_QNA',
               signatureValue: ''
            }
            this.qna = this.signatures.length
            this.signatures.push(qsig)
         }
         this.w9 = this.signatureByType('SIGTYP_W9_CERT')
         if (this.w9==null) {
            let wsig = {
               appointmentId: this.apptId,
               signatureTypeCode: 'SIGTYP_W9_CERT',
               signatureValue: ''
            }
            this.w9 = this.signatures.length
            this.signatures.push(wsig)
         }
      },
      chgCorpTaxId() {
         if (this.apptType == 'APPTTYP_CORP' || this.apptType == 'APPTTYP_VB_CORP' || this.apptType == 'APPTTYP_VB_BOTH') {
            this.irs.employerIdNumber = this.p.businessTaxID
         }
      },
      chgBusTaxId() {
         if (this.apptType == 'APPTTYP_CORP' || this.apptType == 'APPTTYP_VB_CORP' || this.apptType == 'APPTTYP_VB_BOTH') {
            this.p.businessTaxID = this.irs.employerIdNumber
         }
      },         
      storeW9Info(isInitCall){
         var name = (this.p.firstName + ' ' + this.p.middleName + ' ' + this.p.lastName).split('null').join('');
         if(name.replace(/ /g, '').length > 0)
            this.irs.name = name

         if (this.apptType == 'APPTTYP_CORP' || this.apptType == 'APPTTYP_VB_CORP' || this.apptType == 'APPTTYP_VB_BOTH'){            
               this.irs.businessName = this.p.businessName
         }

         if(isInitCall)
            this.chg()
      },
      addressByType(typ) {
         if (this.adrs === undefined) return null
         let itm = null
         this.adrs.forEach((element, indx) => {
            if (element.addressTypeCode == typ) {
               itm = element
               if (typ == 'ADRTYP_HOME')
                  this.homeAddressIndex = indx
               else
                  this.bizAddressIndex = indx
            }
         })
         return itm
      },
      signatureByType(typ) {
         if (this.signatures === undefined) return null
         let i = null
         this.signatures.forEach((element, indx) => {
            if (element.signatureTypeCode == typ) {
               i = indx
            }
         })
         return i
      },
      sigUpdate(evt) {
         // If user fills in first signature, populate all the rest from that data...
         if (evt.target.value != '') { // use this sig to drive all others
            this.$store.commit('updateSignature', evt.target.value)
            this.signatures[this.w9].signatureValue = evt.target.value
         }
         this.chg()
      },
      updateAgentName() {    
         //If the names changes, automatically populate all other name fields
         if (this.p.firstName != null && this.p.firstName != ''
               && this.p.middleName != null && this.p.middleName != '' 
               && this.p.lastName != null && this.p.lastName != '') {
               //We have first name, middle name and last name.
            this.agentName = (this.p.firstName.length >= 2 ? this.p.firstName.charAt(0).toUpperCase() + this.p.firstName.slice(1).toLowerCase() : this.p.firstName.charAt(0).toUpperCase())+ 
                              ' ' + this.p.middleName.charAt(0).toUpperCase() + 
                              ' ' + (this.p.lastName.length >= 2 ? this.p.lastName.charAt(0).toUpperCase() + this.p.lastName.slice(1).toLowerCase() : this.p.lastName.charAt(0).toUpperCase())
         } else if (this.p.firstName != null && this.p.firstName != ''  
                     && (this.p.middleName == null || this.p.middleName == '')
                     && this.p.lastName != null && this.p.lastName != '') {
            //We have first name and last name.            
            this.agentName = (this.p.firstName.length >= 2 ? this.p.firstName.charAt(0).toUpperCase() + this.p.firstName.slice(1).toLowerCase() : this.p.firstName.charAt(0).toUpperCase()) + 
                              ' ' + (this.p.lastName.length >= 2 ? this.p.lastName.charAt(0).toUpperCase() + this.p.lastName.slice(1).toLowerCase() : this.p.lastName.charAt(0).toUpperCase())
         } else if ((this.p.firstName == null || this.p.firstName == '') 
               && this.p.middleName != null && this.p.middleName != '' 
               && this.p.lastName != null && this.p.lastName != '') {
            //We have middle name and last name.         
            this.agentName = this.p.middleName.charAt(0).toUpperCase() + 
                              ' ' + (this.p.lastName.length >= 2 ? this.p.lastName.charAt(0).toUpperCase() + this.p.lastName.slice(1).toLowerCase() : this.p.lastName.charAt(0).toUpperCase())
         } else if (this.p.firstName != null && this.p.firstName != ''
               && this.p.middleName != null && this.p.middleName != '' 
               && (this.p.lastName == null || this.p.lastName == '')) {
            //We have first name and middle name.
            this.agentName = (this.p.firstName.length >= 2  ? this.p.firstName.charAt(0).toUpperCase() + this.p.firstName.slice(1).toLowerCase() : this.p.firstName.charAt(0).toUpperCase()) + 
                              ' ' + this.p.middleName.charAt(0).toUpperCase()                              
         } else if ((this.p.firstName == null || this.p.firstName == '')
               && this.p.middleName != null && this.p.middleName != '' 
               && (this.p.lastName == null || this.p.lastName == '')) {
            //We have middle name only.
            this.agentName = this.p.middleName.charAt(0).toUpperCase()                        
         } else if (this.p.firstName != null && this.p.firstName != '' 
               && (this.p.middleName == null || this.p.middleName == '') 
               && (this.p.lastName == null || this.p.lastName == '')) {
            //We have first name only.
            this.agentName = this.p.firstName.length >= 2 ? this.p.firstName.charAt(0).toUpperCase() + this.p.firstName.slice(1).toLowerCase() : this.p.firstName.charAt(0).toUpperCase()
         } else if ((this.p.firstName == null || this.p.firstName == '')
               && (this.p.middleName == null || this.p.middleName == '') 
               && this.p.lastName != null && this.p.lastName != '' ) {
            //We have last name only.
            this.agentName = this.p.lastName.length >= 2 ? this.p.lastName.charAt(0).toUpperCase() + this.p.lastName.slice(1).toLowerCase() : this.p.lastName.charAt(0).toUpperCase()
         } else if ((this.p.firstName == null || this.p.firstName == '')
               && (this.p.middleName == null || this.p.middleName == '') 
               && (this.p.lastName == null || this.p.lastName == '')) {
            //Nothing fill out.  Reset to empty.
            this.agentName = ''
         }

         if (this.agentName != '') {
            this.$store.commit('updateAgentName',this.agentName)
            //Update Agent Names 
            this.agtN = this.signatureByType('SIGTYP_COMSCHED_AGT')
            if (this.agtN != null) {
               this.signatures[this.agtN].signatureValue = this.agentName
            }
            this.agreeAgtN = this.signatureByType('SIGTYP_AGREENAME')
            if (this.agreeAgtN != null) {
               this.signatures[this.agreeAgtN].signatureValue = this.agentName
            }
         }

         this.chg()         
      },
      isSub(q) {
         return (q.questionText.substr(1,1)==')')
      },
      showType(tarr) {
         return this.$parent.showType(tarr, this.apptType)
      },
      saveAddChg() {
         if (this.copyAddress) {
            this.bizAddress.address1 = this.homeAddress.address1 
            this.bizAddress.address2 = this.homeAddress.address2
            this.bizAddress.city = this.homeAddress.city
            this.bizAddress.stateCode = this.homeAddress.stateCode
            this.bizAddress.zipCode = this.homeAddress.zipCode
         }
      },  
      // report the changes to the parent
      chg(fromEmail) {

         if(fromEmail){
            this.p.emailAddress = this.p.emailAddress.toLowerCase()
         }
         if (this.gettingSigs) return

         // If any address2 has a value, clear it before emitting so parent/server uses combined address logic
         if (this.initialized && Array.isArray(this.adrs)) {
            this.adrs.forEach(addr => {
               if (addr && addr.address2) {
                  addr.address2 = ''
               }
            })
         }

         this.$emit('update', 
            { 
               personal: this.p, 
               addresses: this.adrs, 
               signatures: this.signatures,
               irsInfo: this.irs,
               answers: this.answerCol,
               comments: this.comment
            }
         )
      },
      irsInfoBusinessNameChange()
      {
         if (this.apptType == 'APPTTYP_CORP' || this.apptType == 'APPTTYP_VB_CORP' || this.apptType == 'APPTTYP_VB_BOTH'){
            this.p.businessName = this.irs.businessName
         }
      }
   }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/colors.scss";
@import "../../assets/css/application.scss";
@import "../../assets/css/validation.scss";

.question-table {
   font-size: 0.75em;
}
   .question-table .yn-col {
      min-width: 20%;
      width: 20%;
   }
.poor-indent {
   display: inline-block;
   width: 24px;
   min-width: 24px;
}   
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #000;
  background-color: #000;
}
.custom-control-label {
   display: inline-block;
   padding-top: 8px;
}
.tderror--label {
   color: #990000;
   background-color: #FFCCCC;
}
.comment-field {
   margin-top: 24px;
   margin-bottom: 24px;
}
.comment-field textarea {
   font-size: smaller;
}
.disc {
   border-top: 1px solid #eee;
}
.copy-addr {
   margin-left: 80px;
}
.chk-mail-adr-label {
   text-align: left;
   margin-left: 65px;
   padding-top: 4px;
}

@media (max-width: 575.98px) {
   .col-form-label {
      text-align: left;
   }
}
</style>